module.exports = __webpack_public_path__ + "img/icon-promotion.6d27f08.svg";